module.exports = {
    NAME_CONSTANTS: {
        namePrefix: 'PREFIX',
        givenName: 'FIRSTNAME',
        middleName: 'MIDDLENAME',
        surname: 'LASTNAME',
        nameSuffix: 'SUFFIX',
        altName: 'ALT_NAME',
    },
    DATE_CONSTANTS: {
        US: {
            PAYOUT_DATE: '25',
        },
        CA: {
            PAYOUT_DATE: '30',
        },
    },
    PAGE_CONSTANTS: {
        INTIAL_PAGE_NO: '1',
        PAGE_SIZE_TEN: '10',
        PPGF_ACC_CLOSED: 'Closed',
        PPGF_ACC_CONFIRMED: 'confirmed',
        PAGES: {
            DASHBOARD: 'dashboard',
            CLOSED_ACC: 'closed-acc',
            GRANT: 'GRANT',
            GRANT_MAKER: 'GRANT_MAKER',
            GIVING_HOME: 'giving-home',
        },
        IS_REFUNDS: ['1', '2'],
        AMOUNT_SIGN: {
            PLUS: 'pos',
            MINUS: 'neg',
        },
        NONPROFIT_MCCCODE: 8398,
    },
    ERR_CONSTANTS: {
        desc: 'descError',
        missionArea: 'missionAreaError',
        phone: 'phoneError',
        keywords: 'keywordsError',
        cta: 'ctaError',
        email: 'emailError',
        email2: 'email2Error',
        firstName: 'firstNameError',
        lastName: 'lastNameError',
    },
    ROUTE_PATH: {
        ACTIVITY: ['/activity', '/activity/'],
        PROFILE: ['/profile', '/profile/'],
        DASHBOARD: ['/dashboard', '/dashboard/'],
        DEFAULT_PATH: ['/'],
        HOME_PAGE: ['/home', '/home/'],
        OBS_URL: ['/preenroll', '/preenroll/'],
        TERMS_CONDITIONS: ['/termsandconditions', '/termsandconditions/'],
        POLICIES: ['/policies', '/donation-delivery', '/donation-refunds', '/user-agreement',
            '/privacy', '/nonprofit-certification', '/non-profits', '/item-cancellation',
            '/policies/', '/donation-delivery/', '/donation-refunds/', '/user-agreement/',
            '/privacy/', '/nonprofit-certification/', '/non-profits/', '/item-cancellation/'],
        ENROLL: ['/enrollInPPGF', '/transferCode', '/enroll'],
        HELP_REDIRECTS: ['/charity', '/donors', '/faq', '/charity/', '/donors/', '/faq/'],
        ABOUT_REDIRECT: ['/about', '/about/'],
        CONTACT_REDIRECT: ['/contact', '/contact-confirmation', '/contact/', '/contact-confirmation/'],
        PARTNER_LIST: ['/partner-list', '/partner-list/'],
    },
    ENROLL_CHAR_COUNT: {
        DESCRIPTION: 400,
        KEYWORDS: 200,
        SLOGAN: 90,
    },
    FB_FUNDRAISING_COUNTRIES: ['AU', 'CA', 'GB'],
    EBAY_PPHERE_COUNTRIES: ['US', 'GB'],
    AUTO_ENROLL_COUNTRIES: ['CA', 'IE'],
    DOWNLOAD_FIELDS: {
        PAYOUT_ALP_FIELDS: ['payoutDate', 'donationDate', 'donorFirstName', 'donorLastName',
            'donorEmail', 'program', 'referenceInformation', 'currencyCode', 'grossAmount', 'totalFees', 'netAmount'],
        PAYOUT_ALP_HEADER: ['Payout Date', 'Donation Date', 'Donor First Name', 'Donor Last Name', 'Donor Email', 'Program Name', 'Reference Information', 'Currency Code', 'Gross Amount', 'Total Fees', 'Net Amount'],
        PAYOUT_FIELDS: ['payoutDate', 'donationDate', 'donorName', 'donorEmail', 'program', 'campaignTitle', 'eBayListingId', 'currencyCode', 'amount'],
        PAYOUT_HEADER: ['Payout Date', 'Donation Date', 'Donor Name', 'Donor Email', 'Program', 'Campaign Title', 'eBay Listing ID', 'Currency Code', 'Amount'],
        DONATIONS_FIELDS: ['donationDate', 'donorFirstName', 'donorLastName',
            'donorEmail', 'program', 'referenceInformation', 'currencyCode', 'grossAmount', 'totalFees', 'netAmount'],
        DONATION_HEADER: ['Date', 'Donor First Name', 'Donor Last Name', 'Donor Email', 'Program Name', 'Reference Information', 'Currency Code', 'Gross Amount', 'Total Fees', 'Net Amount'],
        GRANT_FIELDS: ['payoutDate', 'expiryDate', 'grantPayoutId', 'grantMakerName', 'grantAccountName', 'donorTitle', 'donorFirstName', 'donorMiddleName', 'donorLastName', 'donorSuffix', 'donorEmail', 'jointDonorTitle', 'jointDonorFirstName', 'jointDonorMiddleName', 'jointDonorLastName', 'jointDonorSuffix', 'jointDonorEmail', 'addressLine1', 'addressLine2', 'city', 'state', 'postalCode', 'countryCode', 'payoutStatus', 'completedStatusTime', 'failedStatusTime', 'declineReason', 'updatedBy', 'paymentMethod', 'programName', 'purpose', 'attribution', 'notes', 'grantLetterStatus', 'amount', 'currencyCode'],
        GRANT_HEADER: ['Date Issued', 'Expiration Date', 'Grant Payment ID', 'Grantmaker Name', 'Account Name', '1st donor title', '1st donor first name', '1st donor middle initial', '1st donor last name', '1st donor suffix', '1st donor email', '2nd donor title', '2nd donor first name', '2nd donor middle initial', '2nd donor last name', '2nd donor suffix', '2nd donor email', 'Address Line 1', 'Address Line 2', 'City', 'State', 'Zip Code', 'Country', 'Status', 'Completed Date', 'Failed Date', 'Decline Reason', 'Logged In User', 'Payment Method', 'Program name', 'Purpose', 'Additional Info', 'Notes', 'Grant Letter Availability', 'Grant Amount', 'Grant Currency'],
        GRANT_MAKER_FIELDS: ['payoutDate', 'expiryDate', 'grantPayoutId', 'nonProfitName', 'grantAccountName', 'donorTitle', 'donorFirstName', 'donorMiddleName', 'donorLastName', 'donorSuffix', 'donorEmail', 'jointDonorTitle', 'jointDonorFirstName', 'jointDonorMiddleName', 'jointDonorLastName', 'jointDonorSuffix', 'jointDonorEmail', 'addressLine1', 'addressLine2', 'city', 'state', 'postalCode', 'countryCode', 'payoutStatus', 'completedStatusTime', 'failedStatusTime', 'declineReason', 'updatedBy', 'paymentMethod', 'programName', 'purpose', 'attribution', 'notes', 'grantLetterStatus', 'amount', 'currencyCode'],
        GRANT_MAKER_HEADER: ['Date Issued', 'Expiration Date', 'Transaction ID', 'Charity Name', 'Account Name', '1st donor title', '1st donor first name', '1st donor middle initial', '1st donor last name', '1st donor suffix', '1st donor email', '2nd donor title', '2nd donor first name', '2nd donor middle initial', '2nd donor last name', '2nd donor suffix', '2nd donor email', 'Address Line 1', 'Address Line 2', 'City', 'State', 'Zip Code', 'Country', 'Status', 'Completed Date', 'Failed Date', 'Decline Reason', 'Logged In User', 'Payment Method', 'Program name', 'Purpose', 'Additional Info', 'Notes', 'Grant Letter Availability', 'Grant Amount', 'Grant Currency'],
    },
    AUTO_ENROLL_FIELDS: {
        DECISION_MANUAL: 'MANUAL',
        DECISION_PENDING: 'PENDING',
        DECISION_REJECTED: 'REJECTED',
        DECISION_ENROLLED: 'ENROLLED',
        DECISION_NOT_ELIGIBLE: 'NOT_ELIGIBLE',
        CREATE_OR_UPDATE_PPGF_INTENT: 'CREATE_OR_UPDATE_GIVING_FUND',
        DIRECT_MODEL_ENROLLMENT_OPERATIONS: 'DIRECT_MODEL_ENROLLMENT_OPERATIONS',
        PPGF_SUBMIT_ENROLL_STATUS: 'CREATED',
        PPGF_STATUS_CLOSED: 'DELETED',
        PPGF_ENROLLED: 'PPGF_ENROLLED',
    },
    SMARTHELP_NONPROFIT_COUNTRIES: ['CA', 'AU', 'GB'],
    SMARTHELP_FAQ_COUNTRIES: ['US'],
    SMARTHELP_WEB_FORM: ['IE'],
    TAX_IDENTIFIER_LABEL: { GB: 'Charity commission number', AU: 'ABN', IE: 'Charity number', CA: 'CRA number', US: 'EIN', DEFAULT: 'Tax ID number' },
    ACCOUNT_TYPE: { BUSINESS: 'BUSINESS' },
    LIMITATION_STATUS: { ACTIVE: 'ACTIVE', APPEAL_DENIED: 'APPEAL_DENIED' },
    DATE_DM_LEGAL_UPDATE: '2022-06-17',
    PPGF_XB_CURRENCY_CODE: 'EUR',
    MONTH_ARRAY: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
    DAY_ARRAY: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
    BRAZIL: 'BR',
    PPCC_BENEFITS_HEADERFOOTER: ['US', 'GB'],
    GRANTS_DOWNLOAD_STATUS_MAP: {
        charity: {
            PENDING: 'Pending',
            PROCESSING: 'Processing',
            COMPLETED: 'Completed',
            EXPIRED: 'Expired',
            CANCELLED: 'Declined',
            FAILED: 'Failed',
            UNCLAIMED: 'On hold',
            RECALLED: 'Recalled',
            INVALID: 'Invalid grant',
            RETURNED: 'Failed',
        },
        gm: {
            PENDING: 'Pending',
            PROCESSING: 'Processing',
            COMPLETED: 'Completed',
            EXPIRED: 'Expired',
            CANCELLED: 'Declined',
            FAILED: 'Failed',
            UNCLAIMED: 'On hold',
            RECALLED: 'Recalled',
            INVALID: 'Invalid grant',
            RETURNED: 'Returned',
        },
    },
    UGCM_INPUTS: ['keywords', 'description', 'slogan'],
    UGCM_RETRY: { retriesLeft: 3, retryInterval: 3000 },
    ADD_BANK_ACCOUNT_LINK: '/businesswallet/money/addbank?cancelUrl=/charities/dashboard?autoConfirm=true&returnUrl=/charities/dashboard?autoConfirm=true',
    MAX_IMAGE_UPLOAD_SIZE: 12582912,
};
